import { useRequestOAuthDiscoveryUrlMutation } from "@graphql/auth/auth.g";
import { ProviderEnum } from "@graphql/generated/graphql.g";
import { useState } from "react";
import { useNavigate } from "react-router";

import { LoginForm } from "@components/Forms";

import { AffireLogo } from "@design-system/AffireLogo/AffireLogo";
import { Button } from "@design-system/Button/Button";
import { Card } from "@design-system/Card/Card";
import { Text } from "@design-system/Text/Text";

import { routes } from "@pages/routes";

import classes from "./LoginCard.module.css";

export const LoginCard = () => {
  const navigate = useNavigate();
  const [selectedProvider, setSelectedProvider] = useState<ProviderEnum | null>(
    null,
  );
  const requestOauthDiscoveryUrlMutation =
    useRequestOAuthDiscoveryUrlMutation();

  const signInWithProvider = async (provider: ProviderEnum) => {
    const data = await requestOauthDiscoveryUrlMutation.mutateAsync({
      provider,
    });

    const url = data?.requestOauthDiscoveryUrl?.url;

    if (!url) return;

    window.location.href = url;
  };

  const handleSignInWithGoogle = async () => {
    setSelectedProvider(ProviderEnum.Google);
    await signInWithProvider(ProviderEnum.Google);
  };

  const handleSignInWithMicrosoft = async () => {
    setSelectedProvider(ProviderEnum.Microsoft);
    await signInWithProvider(ProviderEnum.Microsoft);
  };

  const onSuccess = () => {
    navigate(routes.login.emailRequest.$path(), { viewTransition: true });
  };

  return (
    <Card>
      <Card.Header>
        <div className={classes.header}>
          <Text spacing="relaxed" size={24} weight={700}>
            Sign in
          </Text>
          <Text size={14} weight={400} color="textSecondary">
            Welcome back! Please signin to continue.
          </Text>
        </div>
        <div className={classes.logo}>
          <AffireLogo height={28} />
        </div>
      </Card.Header>

      <Card.Body gap={8}>
        <LoginForm onSuccess={onSuccess} />
        <Button
          isLoading={
            (requestOauthDiscoveryUrlMutation.isPending ||
              requestOauthDiscoveryUrlMutation.isSuccess) &&
            !requestOauthDiscoveryUrlMutation.isError &&
            selectedProvider === ProviderEnum.Google
          }
          onClick={handleSignInWithGoogle}
          icon="faGoogle"
          stretch
        >
          Sign in with Google
        </Button>
        <Button
          isLoading={
            (requestOauthDiscoveryUrlMutation.isPending ||
              requestOauthDiscoveryUrlMutation.isSuccess) &&
            !requestOauthDiscoveryUrlMutation.isError &&
            selectedProvider === ProviderEnum.Microsoft
          }
          onClick={handleSignInWithMicrosoft}
          icon="faMicrosoft"
          stretch
        >
          Sign in with Microsoft
        </Button>
      </Card.Body>
    </Card>
  );
};
